import { supabase } from 'src/services/supabase-client';
import { Note } from '../types/note';

export async function addNote(note: Note): Promise<void> {
  await supabase.from<Note>('notes').insert(note);
}
